import React, { useEffect, SetStateAction } from 'react';
import { FilterHeaderInputValues } from '../components/filterHeader/props';
import { FilterProps } from '../context/filter';
import { includesInArray } from './includesInArray';
import { getFilterValues } from './url';

export const useFilterHeaderUpdate = (
  isOnInit: boolean,
  section: string,
  patch: (value: SetStateAction<FilterHeaderInputValues>) => void
) => {
  useEffect(() => {
    if (isOnInit) {
      const value =
        getFilterValues(section).join('') || (window as any)[section];

      patch({
        value,
        isOnInit: false,
      });

      if (!(window as any)[section]) {
        (window as any)[section] = value;
      }
    }
  }, [isOnInit]);
};

export const useFilterUpdateWithSections = (
  isOnInit: boolean,
  section: string,
  patch: React.Dispatch<React.SetStateAction<FilterProps>>
) => {
  useEffect(() => {
    if (isOnInit && (window as any)[section]?.length) {
      const filtered = includesInArray(
        (window as any)[section],
        getFilterValues(section)
      );

      patch({ arr: filtered, filtered, isOnInit: false, facet: section });
    }
  }, [(window as any)[section], isOnInit, section]);
};
